module.exports = __webpack_public_path__ + "img/forget.edf0525e.png";